var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeoplehr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M690 1280 l0 -570 590 0 590 0 0 570 0 570 -590 0 -590 0 0 -570z m702 385 c121 -35 228 -145 268 -279 19 -60 15 -173 -8 -239 -39 -108 -151 -229 -193 -206 -11 5 -19 18 -19 28 0 19 67 254 94 330 22 59 20 90 -6 118 -28 30 -63 29 -124 -3 -73 -40 -175 -73 -261 -86 -57 -8 -83 -17 -100 -34 -38 -38 -30 -72 36 -148 73 -85 154 -217 146 -239 -11 -26 -33 -28 -89 -6 -89 33 -160 92 -213 178 -64 102 -70 261 -15 373 91 185 284 269 484 213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1581 c-33 -33 -45 -69 -36 -107 4 -15 20 -39 36 -55 33 -34 85 -39 130 -12 92 54 48 203 -60 203 -32 0 -48 -6 -70 -29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplehr);
export default __webpack_public_path__ + "static/media/peoplehr.53e548238c59c10113a4ade9a2ed4af6.svg";
export { ForwardRef as ReactComponent };